import React from 'react';
import { FaStar } from 'react-icons/fa';

const testimonials = [
  {
    name: 'Nakshatra Kundan Raghuvanshi',
    institution: 'VIT Bhopal',
    rating: 5,
    feedback: 'The lectures for too good, everything was completely explained and taught, doubts were clear time to time , personal attention was given to each student by faculty.It was an amazing experience.'
  },
  {
    name: 'Dhruv Visariya',
    institution: 'J. K. Institute of Applied physics and Technology, ECE',
    rating: 4,
    feedback: 'The robotics workshop was truly captivating! The content was well-structured and engaging, catering to both beginners and experienced individuals. The instructors\' expertise was evident as they explained complex concepts in a simplified manner, ensuring everyone grasped the material.'
  },
  {
    name: 'Prashant Deshmukh',
    institution: 'SSTC Bhilai, Chhattisgarh (B.Tech, CSE)',
    rating: 5,
    feedback: 'The sessions were seamless, with clear explanations from the guide and valuable insights from the industrial professional. Grateful to the entire Internselite Guidance Group for their assistance.'
  },
  {
    name: 'Azhaan Ahmad Khan',
    institution: 'University of Lucknow',
    rating: 4,
    feedback: 'Internselite proves to be an excellent learning platform. I\'m pleased to be a part of it, where the amiable instructors create a friendly learning environment. Kiran Maam\'s invaluable assistance in clearing doubts adds a professional touch to my learning experience.'
  },
  {
    name: 'Devesh Kumar',
    institution: 'Dr. Virendra Swarup Institute of Computer Studies',
    rating: 5,
    feedback: 'The training provided by Internselite was conducted in a very professional and highly intellectual way the our mentor was very helpful and was handled the course in with utmost professionalism.'
  },
  {
    name: 'Rishi Singh',
    institution: 'United College of Engineering and Research',
    rating: 4,
    feedback: 'It\'s great I learned so many things and also I got tremendous experience from our mentor he is amazing and I am happy.'
  }
];

function VLSI_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testmonial</h2>
              <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h2 className='pt-5 display-6'>Hear What Our Students Says</h2>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {testimonials.map((testimonial, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{testimonial.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{testimonial.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {Array.from({ length: 5 }, (_, i) => (
                        <li key={i}>
                          <FaStar color={i < testimonial.rating ? 'gold' : undefined} />
                        </li>
                      ))}
                    </ul>
                    <p className='Review_not_copy'>
                      <i className='fas fa-quote-left pe-2'></i>{testimonial.feedback}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VLSI_Review_Program_Page;
